import api from "./axios";

// -----------------------------
// DTO: Позиция документа
// -----------------------------
export interface WarehouseReceiptItemDto {
  productId: number;
  quantity: number;
  price: number;

  // backend присылает объект товара
  product?: {
    id: number;
    nameRu: string;
    nameKz?: string;
    sku?: string;
    imageUrl?: string;
    [key: string]: any;
  } | null;
}

// -----------------------------
// DTO: Документ прихода
// -----------------------------
export interface WarehouseReceiptDto {
  id: number;
  date: string;
  posted: boolean;

  supplierId: number | null;

  // backend присылает supplier
  supplier?: {
    id: number;
    name: string;
    bin?: string;
    phone?: string;
    email?: string;
    director?: string;
    roles?: string[];
    [key: string]: any;
  } | null;

  items: WarehouseReceiptItemDto[];

  // backend пока отдаёт 0, но поле оставляем
  total: number;
}

// -----------------------------
// DTO: Создание / обновление
// -----------------------------
export interface CreateReceiptDto {
  date: string;
  supplierId?: number;
  items: {
    productId: number;
    quantity: number;
    price: number;
    vat?: number;
  }[];
}

// -----------------------------
// API методы
// -----------------------------
export async function getReceipts(): Promise<WarehouseReceiptDto[]> {
  const res = await api.get("/warehouse/receipts");
  return res.data;
}

export async function deleteReceipt(id: number): Promise<void> {
  await api.delete(`/warehouse/receipts/${id}`);
}



export async function getReceipt(id: number): Promise<WarehouseReceiptDto> {
  const res = await api.get(`/warehouse/receipts/${id}`);
  return res.data;
}

export async function createReceipt(
  dto: CreateReceiptDto
): Promise<WarehouseReceiptDto> {
  const res = await api.post("/warehouse/receipts", dto);
  return res.data;
}

export async function updateReceipt(
  id: number,
  dto: CreateReceiptDto
): Promise<WarehouseReceiptDto> {
  const res = await api.put(`/warehouse/receipts/${id}`, dto);
  return res.data;
}

export async function postReceipt(id: number): Promise<void> {
  await api.post(`/warehouse/receipts/${id}/post`);
}

export async function unpostReceipt(id: number): Promise<void> {
  await api.post(`/warehouse/receipts/${id}/unpost`);
}